var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgReportingNavigationRightIconGrey = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833008 6.63339L0.833008 11.0667C0.833008 11.3229 0.987288 11.5538 1.22399 11.6518C1.4606 11.7499 1.73302 11.6958 1.91415 11.5146L6.98082 6.44795C7.09964 6.32913 7.16635 6.16801 7.16635 6.00005C7.16635 5.83209 7.09964 5.67097 6.98082 5.55224L1.91415 0.485565C1.73302 0.304431 1.4606 0.250252 1.22399 0.348275C0.987288 0.446307 0.833008 0.677246 0.833008 0.9334L0.833008 5.36672L0.833008 6.63339Z",
    fill: "#717C88"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReportingNavigationRightIconGrey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ReportingNavigationRightIconGrey.dc3c5370.svg";
export { ForwardRef as ReactComponent };